import { useState } from 'react';
import { HandleTableData } from '@wajeez-web/components/data-table';
import {
  useCustomerSelector,
  UsersActions,
} from '@wajeez-web/stores/customers';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { DataTableWrapper } from '@wajeez-web/components/helpers';
import { useNavigate } from 'react-router-dom';

const WajeezCustomersPage = () => {
  const navigate = useNavigate();

  const { data, status } = useCustomerSelector((state) => state.users);

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData('users', UsersActions.getAllUsersAsync);

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title="Wajeez Users"
        withoutRightPadding={true}
        breadCrumbsLinks={[{ title: 'Wajeez-users' }]}
      >
        <DataTableWrapper
          data={data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={status === 'loading'}
          rowActions={(row) => {
            return [
              {
                title: 'View',
                action: () => {
                  navigate(`/wajeez-customers/${row[1] as string}/analytics`);
                },
                type: 'request',
                endpoint: 'users',
                permission: '18.10',
              },
            ];
          }}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </PageLayoutsContainer>
    </div>
  );
};

export default WajeezCustomersPage;
